<div *ngIf="processandoAssinaturaGovBr" style="text-align: center;">
  <h1>Aguarde! Registrando assinatura gov.br...</h1>
</div>

<form [formGroup]="formulario.formGroup">
    <br>
    <div class="form-row">
        <div class="col-8">
            <h5>
                {{saudacaoUsuarioExterno}}<br>
                {{mensagemBoasVindas}}
            </h5>
        </div>
    </div>

    <br>

    <div class="form-row" *ngIf="podeVisualizarDetalhesTramite()">
        <div class="form-group col-8">
            {{tituloDocumentoOriginal}} de {{dataDocumentoTramite | date}}
            <label class="control-label small" for="arquivoUpload">
                <span
                    popoverClass="popover-body"
                    popoverTitle="Trâmite"
                    triggers="click:mouseleave"
                    ngbPopover={{descricaoDocumentoTramite}}
                    >
                    <sup>(?)</sup>
                </span>
            </label>
        </div>
    </div>

    <div class="form-row">
        <div [hidden]="!podeExibirDownloadArquivoOriginal()" class="form-group col-8 arquivo-unico">
            <label class="control-label small" for="arquivoOriginal">
                <span
                    popoverClass="popover-body"
                    popoverTitle="Arquivo Original"
                    placement="right"
                    triggers="click:mouseleave"
                    [ngbPopover]="popContentAjudaArquivoOriginal"
                    >
                    Arquivo Original<sup>(?)</sup>
                </span>
                <span [hidden]="!podeExibirDownloadArquivoOriginalSemMarcaDagua()" style="margin-left: 5px" ><a [href]="getUrlArquivoOriginalSemMarcaDagua()" target="_blank">(clique aqui para ver sem marca d´água)</a></span>
            </label>
            <bn-file-uploader #arquivoOriginal id="arquivoOriginal"
                [tipoPermitido]="'application/pdf'"
                [descricao]="false"
                [edicao]="false"
                [exibirMensagemEnvio]="false">
            </bn-file-uploader>
        </div>
    </div>

    <div class="form-row">
        <div [hidden]="!podeExibirDownloadArquivoAssinado()" class="form-group col-8 arquivo-unico">
            <label class="control-label small" for="arquivoAssinado">
                <span
                    popoverClass="popover-body"
                    popoverTitle="Arquivo Assinado"
                    placement="right"
                    triggers="click:mouseleave"
                    [ngbPopover]="popContentAjudaArquivoAssinado"
                    >
                    Arquivo Assinado<sup>(?)</sup>
                </span>
                <span [hidden]="!podeExibirDownloadArquivoAssinadoSemMarcaDagua()" style="margin-left: 5px" ><a [href]="getUrlArquivoAssinadoSemMarcaDagua()" target="_blank">(clique aqui para ver sem marca d´água)</a></span>
            </label>
            <bn-file-uploader #arquivoAssinado id="arquivoAssinado"
                [tipoPermitido]="'application/pdf'"
                [descricao]="false"
                [edicao]="false"
                [exibirMensagemEnvio]="false">
            </bn-file-uploader>
        </div>
    </div>

    <div class="evo-sdk-link" *ngIf="ehColaboradorBNDES()">
    <p>
        Para assinar ICP-Brasil, instale o EVO SDK.<br>
        Faça o download <a href="{{urlEvoSdkDownload}}" target="_blank">aqui</a>
    </p>
    </div>

    <br>

    <div class="form-row" class="painel-acao" *ngIf="podeVisualizarAssinarRejeitar() && podeVisualizarDetalhesTramite()">
        <div class="form-group col-md-12" data-toggle="buttons" style="text-align: left" >
                <button [ngClass]="{'active border border-dark' : tipoAcaoAssinatura == listaTipoAcaoAssinaturaEnum.AssinandoICPBrasil, 'bg-secondary border-0': tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.AssinandoICPBrasil && tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Nenhuma && tipoAcaoAssinatura != null}"
                class="btn btn-sq-lg btn-success"
                (click)="onSelecionarAssinarIcpBrasil()"
                [disabled]="estaRejeitado() || estaAssinadoPeloSignatario() || (tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.AssinandoICPBrasil && tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Nenhuma && tipoAcaoAssinatura != null)">
                    <img src="assets/file-signature-solid-white.svg" alt="*" width="40px" height="40px">
                    <br/>ASSINAR<br/><p *ngIf="ehTipoFormatoAssinaturaQualificada() || ehTipoFormatoAssinaturaEletronicaAvancadaGovBr()">ICP-BRASIL</p>
                </button>
                <button [ngClass]="{'active border border-dark' : tipoAcaoAssinatura == listaTipoAcaoAssinaturaEnum.AssinandoGOVBR, 'bg-secondary border-0': tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.AssinandoGOVBR && tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Nenhuma && tipoAcaoAssinatura != null }"
                *ngIf="ehTipoFormatoAssinaturaEletronicaAvancadaGovBr()"
                class="btn btn-sq-lg govbr"
                (click)="onSelecionarAssinarGovBR()"
                [disabled]="estaRejeitado() || estaAssinadoPeloSignatario() || (tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.AssinandoGOVBR && tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Nenhuma && tipoAcaoAssinatura != null)"
                style="margin-left: 25px;">
                    <img src="assets/file-signature-solid-white.svg" alt="*" width="40px" height="40px">
                    <br/>ASSINAR<br/>GOV.BR
                </button>
                <button [ngClass]="{'active border border-dark' : tipoAcaoAssinatura == listaTipoAcaoAssinaturaEnum.Rejeitando, 'bg-secondary border-0': tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Rejeitando && tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Nenhuma && tipoAcaoAssinatura != null}" class="btn btn-sq-lg btn-danger" style="margin-left: 25px;"
                (click)="onSelecionarRejeitar()"
                [disabled]="estaRejeitado() || estaAssinadoPeloSignatario() || 
                            (tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Rejeitando && 
                                tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Nenhuma && tipoAcaoAssinatura != null)">
                    <i class="fa fa-thumbs-o-down fa-3x" width="50px" height="50px"></i>
                    <br/>REJEITAR
                </button>
        </div>
    </div>

    <br>

    <div *ngIf="tipoAcaoAssinatura == listaTipoAcaoAssinaturaEnum.Rejeitando" class="form-row">
        <div class="form-group col-md-8">
            <label class="control-label small" for="justificativa">Justificativa</label>
            <textarea
                rows="3"
                [formControlName]="formulario.campos.justificativa?.name"
                [attr.maxlength]="formulario.campos.justificativa?.maxLength"
                [attr.required]="formulario.campos.justificativa?.required"
                [attr.placeholder]="formulario.campos.justificativa?.placeHolder"
                (input)="onChangeJustificativa()"
                class="form-control"
                >
            </textarea>
        </div>
    </div>




    <div *ngIf="tipoAcaoAssinatura == listaTipoAcaoAssinaturaEnum.AssinandoGOVBR" class="card-footer bg-transparent">
        <div *ngIf="!estaAutenticadoGovBR()">
          <p>Para utilizar a assinatura eletrônica avançada <strong>gov.br</strong> é necessário se autenticar com sua conta <strong>gov.br</strong>.
          <br>Realize um novo acesso através do link enviado por e-mail
        </p>
        </div>
        <div *ngIf="estaAutenticadoGovBR()">
          <p>É necessário possuir conta gov.br <strong>nível ouro ou prata</strong> para utilizar a assinatura eletrônica avançada. <a href="http://confiabilidades.acesso.gov.br/"  target="_blank">Clique aqui</a> para aumentar o nível da sua conta.</p>
        </div>
    </div>

    <div *ngIf="tipoAcaoAssinatura != null && tipoAcaoAssinatura != listaTipoAcaoAssinaturaEnum.Nenhuma" class="form-row" class="painel-acao">
        <div class="form-group col-md-8" style="text-align: left">
            <button class="btn btn-success btn-sm btn-submit" 
                (click)="confirmarAcao()" 
                *ngIf="podeConfirmarAcaoSelecionada()" 
                [disabled]="estaRejeitado() || estaAssinadoPeloSignatario() ||
                            (tipoAcaoAssinatura == listaTipoAcaoAssinaturaEnum.Rejeitando && !justificativaPreenchida)">
                    <i class="fa fa-check fa-fw"></i>CONFIRMAR
            </button>
            <button class="btn btn-danger btn-sm btn-submit" (click)="cancelarAcaoSelecionada()">
              <i class="fa fa-ban fa-fw"></i>CANCELAR
            </button>
        </div>
    </div>

    <div class="form-row" [hidden]="!podeExibirDownloadAnexos()">
        <div class="form-group col-8">
            Documentos complementares:
        </div>
        <div class="form-group col-8" *ngIf="podeExibirDownloadAnexos() && podeVisualizarDocumentoSemMarcaDagua()">
            <button class="btn nostyle" (click)="onCliqueVisualizarDocumentosComMarcaDagua()">
                <i *ngIf="ehParaRecuperarDocumentosComMarcaDagua()" class="action-icon fa fa-toggle-on" title="Desativar"></i>
                <i *ngIf="!ehParaRecuperarDocumentosComMarcaDagua()" class="action-icon fa fa-toggle-off" title="Ativar"></i>
            </button>
             Recuperar com marca d'água
        </div>
        <div class="form-group col-8" *ngIf="reloadAnexos">
            <bn-file-uploader #anexos
                [tipoPermitido]="'application/pdf'"
                [descricao]="false"
                [disabled]="false"
                [edicao]="false"
                [exibirMensagemEnvio]="false">
            </bn-file-uploader>
        </div>
    </div>

    <div class="box-assinantes shadow-sm p-3 mb-5 bg-light rounded" *ngIf="podeVisualizarDetalhesTramite()">

        <h5 style="color: #495057;">
           Signatários
            <hr style="width: 100% !important;
                       border-bottom: 3px solid #03974A !important;
                       margin-top: -3px;">
        </h5>

        <span *ngFor="let assinatura of assinantes">
            <span
	            popoverClass="popover-body"
                popoverTitle="Situação da Assinatura"
                placement="left"
                triggers="hover:mouseleave"
                ngbPopover="{{getTipoSituacaoAssinatura(assinatura)}}"
            >
                <img src="{{getIcone(assinatura)}}" alt="*" width="20px" height="20px">
                {{assinatura.nomeCompleto}}
            </span>
            <br>
        </span>
    </div>
</form>

<ng-template #popContentAjudaArquivoOriginal>
    <div>
        <div>
            Arquivo a ser assinado.
        </div>
    </div>
</ng-template>

<ng-template #popContentAjudaArquivoAssinado>
    <div>
        <div>
            Para obter o arquivo assinado sem marca d´água solicite para o responsável pelo trâmite ou para um dos destinatários do trâmite que possua permissão de visualização do documento original.
        </div>
    </div>
</ng-template>

